import React from "react";
import { Box, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

import { COLORS } from "constants/colors";
import { termsOfServiceUrls } from "constants/links";

const Footer = ({ soulId }) => {
  const navigate = useNavigate();

  var links = [];

  // "chi_line"がsoul_idに含まれるか
  if (soulId && soulId.includes("chi_line")) {
    links = [
      { label: "ストーリー", path: `/chi/story` },
      { label: "マイページ", path: `/mypage?soul_id=${soulId}` },
      { label: "クエスト一覧", path: `/quests?soul_id=${soulId}` },
      { label: "エピソード購入", path: `/tickets?soul_id=${soulId}` },
      {
        label: "使い方",
        url: "https://sekaie.notion.site/1960a885c19e80b995f4f433c46a5bee",
      },
      { label: "お問い合わせ", url: "https://line.me/R/ti/p/@314jdaww" },
      {
        label: "利用規約",
        url: termsOfServiceUrls.ja,
      },
      {
        label: "プライバシーポリシー",
        url: "https://sekaie.notion.site/1960a885c19e801aa6c5f7cc9e3b4203",
      },
    ];
  } else {
    links = [
      { label: "エピソード一覧", path: `/episodes?soul_id=${soulId}` },
      { label: "ミッション一覧", path: `/quests?soul_id=${soulId}` },
      { label: "エピソード購入", path: `/tickets?soul_id=${soulId}` },
      {
        label: "使い方",
        url: "https://sekaie.notion.site/1960a885c19e80b995f4f433c46a5bee",
      },
      { label: "お問い合わせ", url: "https://line.me/R/ti/p/@314jdaww" },
      {
        label: "利用規約",
        url: termsOfServiceUrls.ja,
      },
      {
        label: "プライバシーポリシー",
        url: "https://sekaie.notion.site/1960a885c19e801aa6c5f7cc9e3b4203",
      },
    ];
  }

  const commonStyles = {
    cursor: "pointer",
    transition: "color 0.2s, transform 0.2s",
    "&:hover": { color: "lightgray", transform: "scale(1.05)" },
    "&:active": { color: "gray", transform: "scale(0.95)" },
  };

  return (
    <Box
      sx={{
        backgroundColor: COLORS.FOOTER,
        // backgroundColor: 'transparent',
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 2,
        pt: 5,
        pb: 5,
        color: "white",
      }}
    >
      {links.map((link, index) => (
        <Typography
          key={index}
          fontSize="13px"
          fontWeight="bold"
          sx={{ commonStyles }}
          onClick={
            link.path
              ? () => navigate(link.path)
              : link.url
              ? () => {
                  window.location.href = link.url;
                }
              : undefined
          }
        >
          {link.label}
        </Typography>
      ))}

      <Typography fontSize="12px" fontWeight="bold" mt={4}>
        © 2025 SekaiE Inc.
      </Typography>
    </Box>
  );
};

export default Footer;
